import admin from "./admin";
import role from "./role";

export default [
  admin,
  role
]
